import React, { useState } from 'react';
import { ShieldCheckIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon, ArrowRightIcon, BuildingIcon, GavelIcon, FileTextIcon, KeyIcon, InfoIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import EscrowProcess from '../components/Escrow/EscrowProcess';
import EscrowDetails from '../components/Escrow/EscrowDetails';
const EscrowServices = () => {
  const [activeTab, setActiveTab] = useState('active');
  // Mock escrow transactions
  const escrowTransactions = [{
    id: 'ESC-12345',
    propertyName: 'Luxury 3 Bedroom Apartment',
    location: 'Lekki Phase 1, Lagos',
    price: '₦75,000,000',
    status: 'In Progress',
    stage: 'Legal Verification',
    image: 'https://images.unsplash.com/photo-1613545325278-f24b0cae1224?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    progress: 40,
    startDate: 'May 10, 2023',
    estimatedCompletion: 'June 15, 2023',
    stages: [{
      name: 'Payment Received',
      status: 'completed',
      date: 'May 10, 2023'
    }, {
      name: 'Legal Verification',
      status: 'in-progress',
      date: 'May 15, 2023'
    }, {
      name: 'Document Processing',
      status: 'pending',
      date: null
    }, {
      name: 'Final Approval',
      status: 'pending',
      date: null
    }, {
      name: 'Fund Release & Key Transfer',
      status: 'pending',
      date: null
    }]
  }, {
    id: 'ESC-12344',
    propertyName: 'Modern 4 Bedroom Duplex',
    location: 'Maitama, Abuja',
    price: '₦120,000,000',
    status: 'In Progress',
    stage: 'Document Processing',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    progress: 60,
    startDate: 'April 28, 2023',
    estimatedCompletion: 'June 5, 2023',
    stages: [{
      name: 'Payment Received',
      status: 'completed',
      date: 'April 28, 2023'
    }, {
      name: 'Legal Verification',
      status: 'completed',
      date: 'May 10, 2023'
    }, {
      name: 'Document Processing',
      status: 'in-progress',
      date: 'May 12, 2023'
    }, {
      name: 'Final Approval',
      status: 'pending',
      date: null
    }, {
      name: 'Fund Release & Key Transfer',
      status: 'pending',
      date: null
    }]
  }];
  const completedTransactions = [{
    id: 'ESC-12343',
    propertyName: 'Waterfront 5 Bedroom Villa',
    location: 'Banana Island, Lagos',
    price: '₦350,000,000',
    status: 'Completed',
    stage: 'Completed',
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    progress: 100,
    startDate: 'March 15, 2023',
    completionDate: 'April 20, 2023',
    stages: [{
      name: 'Payment Received',
      status: 'completed',
      date: 'March 15, 2023'
    }, {
      name: 'Legal Verification',
      status: 'completed',
      date: 'March 28, 2023'
    }, {
      name: 'Document Processing',
      status: 'completed',
      date: 'April 5, 2023'
    }, {
      name: 'Final Approval',
      status: 'completed',
      date: 'April 15, 2023'
    }, {
      name: 'Fund Release & Key Transfer',
      status: 'completed',
      date: 'April 20, 2023'
    }]
  }];
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-1193">
      <div className="container mx-auto px-4 py-8" data-id="element-1194">
        <div className="max-w-4xl mx-auto" data-id="element-1195">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2" data-id="element-1196">
            Escrow Services
          </h1>
          <p className="text-gray-600 mb-8" data-id="element-1197">
            Track and manage your secure property transactions
          </p>
          {/* How Escrow Works */}
          <div className="bg-white rounded-lg shadow-sm p-6 mb-8" data-id="element-1198">
            <div className="flex items-center mb-4" data-id="element-1199">
              <ShieldCheckIcon className="h-8 w-8 text-green-600 mr-3" data-id="element-1200" />
              <h2 className="text-xl font-bold" data-id="element-1201">
                How Our Escrow Service Works
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6" data-id="element-1202">
              <EscrowProcess icon={<BuildingIcon size={24} className="text-blue-600" data-id="element-1204" />} title="Property Selection" description="Select your property and proceed to payment" step={1} data-id="element-1203" />
              <EscrowProcess icon={<ShieldCheckIcon size={24} className="text-blue-600" data-id="element-1206" />} title="Secure Payment" description="Funds are held securely in escrow" step={2} data-id="element-1205" />
              <EscrowProcess icon={<GavelIcon size={24} className="text-blue-600" data-id="element-1208" />} title="Legal Verification" description="Property documents are verified" step={3} data-id="element-1207" />
              <EscrowProcess icon={<FileTextIcon size={24} className="text-blue-600" data-id="element-1210" />} title="Documentation" description="All legal paperwork is processed" step={4} data-id="element-1209" />
              <EscrowProcess icon={<KeyIcon size={24} className="text-blue-600" data-id="element-1212" />} title="Fund Release" description="Property transfer & key delivery" step={5} data-id="element-1211" />
            </div>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-1213">
              <div className="flex items-start" data-id="element-1214">
                <InfoIcon size={20} className="text-blue-600 mr-3 mt-0.5" data-id="element-1215" />
                <div data-id="element-1216">
                  <h4 className="text-blue-800 font-medium" data-id="element-1217">
                    DiasporaHomes Escrow Protection
                  </h4>
                  <p className="text-blue-800 text-sm mt-1" data-id="element-1218">
                    Our escrow service ensures your funds are only released when
                    all conditions of the property purchase are met. This
                    protects both buyers and sellers throughout the transaction
                    process.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Escrow Transactions */}
          <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-8" data-id="element-1219">
            <div className="border-b border-gray-200" data-id="element-1220">
              <div className="flex" data-id="element-1221">
                <button className={`px-6 py-3 font-medium ${activeTab === 'active' ? 'text-green-600 border-b-2 border-green-600' : 'text-gray-700 hover:text-green-600'}`} onClick={() => setActiveTab('active')} data-id="element-1222">
                  Active Escrows
                </button>
                <button className={`px-6 py-3 font-medium ${activeTab === 'completed' ? 'text-green-600 border-b-2 border-green-600' : 'text-gray-700 hover:text-green-600'}`} onClick={() => setActiveTab('completed')} data-id="element-1223">
                  Completed
                </button>
              </div>
            </div>
            <div className="p-6" data-id="element-1224">
              {activeTab === 'active' ? <>
                  {escrowTransactions.map(transaction => <EscrowDetails key={transaction.id} transaction={transaction} data-id="element-1225" />)}
                </> : <>
                  {completedTransactions.map(transaction => <EscrowDetails key={transaction.id} transaction={transaction} data-id="element-1226" />)}
                </>}
            </div>
          </div>
          {/* Start New Escrow */}
          <div className="bg-green-600 text-white rounded-lg p-6 text-center" data-id="element-1227">
            <h2 className="text-2xl font-bold mb-3" data-id="element-1228">
              Ready to Start a New Property Purchase?
            </h2>
            <p className="mb-6 text-lg" data-id="element-1229">
              Browse our verified properties and secure your investment with our
              escrow service.
            </p>
            <Link to="/properties" className="inline-flex items-center bg-white text-green-600 px-6 py-3 rounded-lg font-bold hover:bg-gray-100 transition" data-id="element-1230">
              Browse Properties
              <ArrowRightIcon size={16} className="ml-2" data-id="element-1231" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default EscrowServices;